<button (click)="toggleMenuEvents()" id="collapse_menu" class="collapse_menu">
  @if (_expanded) {
    <span id="closebut" class="opclosebut" style="display: block;">close </span>
  } @else {
    <span id="openbut" class="opclosebut">open &gt;</span>
  }
</button>

<ul id="js-menu" class="menu">
  @for (item of menuItems; track item.label || item.route || $index) {
    @if (item.visible) {
      <li class="menu--item menu--item__has_sub_menu" [class.menu--item__has_sub_menu]="item.children && item.children.length > 0">
        <!-- Direct Menu Link -->
        @if (!item.children || item.children.length === 0) {
          <a [routerLink]="item.route" class="menu--link">
            @if (item.icon) {
              <img class="menu--icon" [src]="'/assets/menu/'+ (theme || 'enterprise') +'/' + item.icon" />
            }
            <span class="menu--label">{{item.label}}</span>
          </a>
        }
        <!-- Menu Link with Submenu -->
        @if (item.children && item.children.length > 0) {
          <label class="menu--link">
            @if (item.icon) {
              <img class="menu--icon" [src]="'/assets/menu/'+ (theme || 'enterprise') +'/' + item.icon" />
            }
            <span class="menu--label">{{item.label}}</span>
            <span class="after_arrow"></span>
          </label>
          <ul class="sub_menu">
            @for (child of item.children; track child.label || child.route || $index) {
              <!-- Authorization Section Header -->
              @if (child.isAuthorization) {
                @if (child.visible) {
                  <li class="sidebar-divider"></li>
                }
                @if (child.visible) {
                  <li class="sidebar-subheader">{{child.label}}</li>
                }
              }
              <!-- Standard SubMenu Item -->
              @if (child.visible && !child.isAuthorization) {
                <li class="sub_menu--item">
                  <a [routerLink]="child.route" class="sub_menu--link-new">
                    @if (child.icon) {
                      <img class="sub-menu--icon" [src]="'/assets/menu/'+ (theme || 'enterprise') +'/' + child.icon" />
                    }
                    <span class="sub-menu--label">{{child.label}}</span>
                  </a>
                  @if (child.scope) {
                    <div class="sub_menu--link--absolute">
                      @if (canAccess(child.scope, 'create') && hasAddForm(child)) {
                        <a (click)="_openChildForm(child)">
                          <img [src]="'/assets/menu/'+ (theme || 'enterprise') +'/stock-add-new-icon.svg'" />
                        </a>
                      }
                      <a (click)="$event.stopPropagation(); _favorite(getFavoriteScope(child), item.label || 'Files')">
                        <img [src]="'/assets/menu/'+ (theme || 'enterprise') +'/'+ getFavoriteUrl(getFavoriteScope(child))" />
                      </a>
                    </div>
                  }
                </li>
              }
            }
          </ul>
        }
      </li>
    }
  }
</ul>